/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { employeeDirectoryService } from '../../api/services/employeeDirectoryService';
import { performanceService } from '../../api/services/performanceService';
import { setLoading } from '../../infra/aggregates/LoaderSlice';
import {
  setEmployeeData,
  setPerformanceData,
  setPerformanceSearchData,
  setPage,
  setMyTeamEmployees,
  setPerformanceStatusFilter,
  setKpiTableLoader,
  setTablePageSize,
  setPerformanceStatusCount,
} from '../../infra/aggregates/myProfile/Performance/Performance';
import { useAppDispatch, useAppSelector } from '../../infra/hooks';
import toast from 'react-hot-toast';

interface PropsValues {
  setEmpDirectory: (data: any) => void;
  setAllDepartments: (data2: any) => void;
  setTotalEmpDirectory: (total: any) => void;
  pageNumber: any;
}

function DTOPerfomance({
  setEmpDirectory,
  setTotalEmpDirectory,
  setAllDepartments,
  pageNumber,
}: PropsValues) {
  const dispatch = useAppDispatch();
  const performanceSwitch = useAppSelector(
    (state) => state.PerformanceSlice?.performanceSwitch,
  );
  const performanceSearchData = useAppSelector(
    (state) => state.PerformanceSlice?.performanceSearchData,
  );
  const performanceStatusFilter = useAppSelector(
    (state) => state.PerformanceSlice?.performanceStatusFilter,
  );
  const apiTrigger = useAppSelector(
    (state) => state.evaluatorDetails?.apiTrigger,
  );
  const pageNumbers = useAppSelector((state) => state.PerformanceSlice?.page);
  const pageSize = useAppSelector(
    (state) => state.PerformanceSlice?.tablePageSize,
  );
  const selector = useAppSelector((state) => state.authSlice);
  const companyId = useAppSelector((state) => state.authSlice.company_id);
  const employeeId = useAppSelector((state) => state.authSlice.emp_id);
  const userId = useAppSelector((state) => state.authSlice.user_id);

  const full_path = '';

  async function getEmployeeDirectory(companyId: number, full_path: string) {
    dispatch(setLoading(true));
    const response: any = await employeeDirectoryService.getallEmpData(
      companyId,
      full_path,
    );
    if (response.response == 'success') {
      dispatch(setLoading(false));
      setTotalEmpDirectory(response?.data?.data.length);
      const empDirectory: any = response?.data?.data.slice(0, 18);
      // dispatch(setEmployeeActiveDocs(empDocsData));
      /* Passing Props to Controller */
      setEmpDirectory(empDirectory);
    } else {
      dispatch(setLoading(false));
      return;
    }
  }

  async function getAllDepartments() {
    const response =
      await employeeDirectoryService.getDepartmentList(companyId);
    if (response) {
      const { data }: any = response;
      setAllDepartments(data);
    }
  }
  useEffect(() => {
    getAllDepartments();
    if (selector.company_id)
      getEmployeeDirectory(selector.company_id, full_path);
  }, []);

  async function getEmployeeDirectoryByPage(
    pageNumber: any,
    companyId: number,
    full_path: string,
  ) {
    const response: any = await employeeDirectoryService.getallEmpData(
      companyId,
      full_path,
    );
    if (response.response == 'success') {
      const empDirectory: any = response?.data.slice(
        pageNumber?._from,
        pageNumber?._to,
      );
      setEmpDirectory(empDirectory);
    } else {
      return;
    }
  }

  useEffect(() => {
    getAllDepartments();
    if (pageNumber._from || pageNumber._to)
      getEmployeeDirectoryByPage(pageNumber, selector.company_id, full_path);
  }, [pageNumber]);

  useEffect(() => {
    getEmployeeDetails();
    getMyTeamEmployees();
  }, []);

  //GET  Employee details
  async function getEmployeeDetails() {
    const response: any =
      await performanceService.getEmployeeDetail(employeeId);
    if (response.response == 'success') {
      dispatch(setEmployeeData(response));
    } else {
      console.error('Response was not successful');
      return;
    }
  }

  useEffect(() => {
    if (performanceSwitch) {
      getTeamData(
        selector.emp_id,
        selector?.user_id,
        pageNumbers * pageSize,
        pageSize,
      );
      getMyTeamStatusCount(selector?.emp_id, selector?.user_id);
    } else {
      getPerfomanceData(
        selector?.emp_id,
        selector?.user_id,
        pageNumbers * pageSize,
        pageSize,
      );
      getMyPerformanceStatusCount(selector?.emp_id, selector?.user_id);
    }
  }, [performanceSwitch]);

  useEffect(() => {
    if (apiTrigger) {
      if (performanceSwitch && !performanceStatusFilter)
        getTeamDataBySearch(
          selector?.emp_id,
          selector?.user_id,
          performanceSearchData,
          pageNumbers * pageSize,
          pageSize,
        );
      else if (performanceSwitch && !performanceSearchData)
        getTeamDataByFilter(
          selector?.emp_id,
          selector?.user_id,
          performanceStatusFilter,
          pageNumbers * pageSize,
          pageSize,
        );
      else if (
        performanceSwitch &&
        performanceStatusFilter &&
        performanceSearchData
      )
        getTeamDataBySearchAndFilter(
          selector?.emp_id,
          selector?.user_id,
          performanceStatusFilter,
          performanceSearchData,
          pageNumbers * pageSize,
          pageSize,
        );
      else if (!performanceSwitch && !performanceStatusFilter)
        getPerfomanceDataBySearch(
          selector?.emp_id,
          selector?.user_id,
          performanceSearchData,
          pageNumbers * pageSize,
          pageSize,
        );
      else if (!performanceSwitch && !performanceSearchData)
        getPerfomanceDataByFilter(
          selector?.emp_id,
          selector?.user_id,
          performanceStatusFilter,
          pageNumbers * pageSize,
          pageSize,
        );
      else if (
        !performanceSwitch &&
        performanceStatusFilter &&
        performanceSearchData
      )
        getPerfomanceDataBySearchAndFilter(
          selector?.emp_id,
          selector?.user_id,
          performanceStatusFilter,
          performanceSearchData,
          pageNumbers * pageSize,
          pageSize,
        );
      else return;
    }
  }, [apiTrigger]);

  //GET Team Data
  async function getTeamData(
    employeeId: number,
    current_user_id: number,
    skip: number,
    limit: number,
  ) {
    dispatch(setKpiTableLoader(true));
    try {
      const response: any = await performanceService.getMyTeamData(
        employeeId,
        current_user_id,
        skip,
        limit,
      );
      dispatch(setPerformanceData(response?.data));
      dispatch(setPerformanceSearchData(''));
      dispatch(setPerformanceStatusFilter(''));
      dispatch(setTablePageSize(10));
      dispatch(setPage(0));
      dispatch(setKpiTableLoader(false));
    } catch (error) {
      dispatch(setPerformanceSearchData(''));
    }
  }
  //GET  Team Data By Filter
  async function getTeamDataByFilter(
    employeeId: number,
    current_user_id: number,
    status: string,
    skip: number,
    limit: number,
  ) {
    try {
      const response: any = await performanceService.getMyTeamDataByFilter(
        employeeId,
        current_user_id,
        status,
        skip,
        limit,
      );
      dispatch(setPerformanceData(response?.data));
    } catch (err: any) {
      console.log(err.message);
    }
  }
  async function getMyPerformanceStatusCount(
    currentEmployeeId: number,
    currentUserId: number,
  ) {
    try {
      const response =
        await performanceService.getMyPerformanceDataByStatusCount(
          currentEmployeeId,
          currentUserId,
        );
      dispatch(setPerformanceStatusCount(''));
      dispatch(setPerformanceStatusCount(response?.data));
    } catch (err: any) {
      console.log(err.message);
    }
  }
  async function getMyTeamStatusCount(
    currentEmployeeId: number,
    currentUserId: number,
  ) {
    try {
      const response = await performanceService.getMyTeamDataByStatusCount(
        currentEmployeeId,
        currentUserId,
      );
      dispatch(setPerformanceStatusCount(''));
      dispatch(setPerformanceStatusCount(response?.data));
    } catch (err: any) {
      console.log(err.message);
    }
  }
  //GET  Team Data By Search
  async function getTeamDataBySearch(
    current_employee_id: number,
    current_user_id: number,
    search: string,
    skip: number,
    limit: number,
  ) {
    try {
      const response: any = await performanceService.getMyTeamDataBySearch(
        current_employee_id,
        current_user_id,
        search,
        skip,
        limit,
      );
      dispatch(setPerformanceData(response?.data));
    } catch (err: any) {
      console.log(err.message);
    }
  }
  //GET  Team Data By Search and Filter
  async function getTeamDataBySearchAndFilter(
    current_employee_id: number,
    current_user_id: number,
    status: string,
    search: string,
    skip: number,
    limit: number,
  ) {
    try {
      const response: any =
        await performanceService.getMyTeamDataBySearchAndFilter(
          current_employee_id,
          current_user_id,
          status,
          search,
          skip,
          limit,
        );
      dispatch(setPerformanceData(response?.data));
    } catch (error: any) {
      console.error('something went wrong');
    }
  }
  //GET Performance Data
  async function getPerfomanceData(
    current_employee_id: number,
    current_user_id: number,
    skip: number,
    limit: number,
  ) {
    try {
      dispatch(setKpiTableLoader(true));
      const response: any = await performanceService.getMyPerformanceData(
        current_employee_id,
        current_user_id,
        skip,
        limit,
      );
      if (response.status === 200) {
        dispatch(setPerformanceData(response?.data));
        dispatch(setPerformanceSearchData(''));
        dispatch(setPerformanceStatusFilter(''));
        dispatch(setTablePageSize(10));
        dispatch(setPage(0));
        dispatch(setKpiTableLoader(false));
      }
    } catch (error: any) {
      toast.error("My don't have evaluation sheet belongs to you");
    }
  }
  //GET Performance Data By Filter
  async function getPerfomanceDataByFilter(
    current_employee_id: number,
    current_user_id: number,
    status: string,
    skip: number,
    limit: number,
  ) {
    const response: any = await performanceService.getMyPerformanceDataByFilter(
      current_employee_id,
      current_user_id,
      status,
      skip,
      limit,
    );
    if (response.status === 200) {
      dispatch(setPerformanceData(response?.data));
    } else {
      return;
    }
  }
  //GET Performance Data By Search
  async function getPerfomanceDataBySearch(
    current_employee_id: number,
    current_user_id: number,
    search: string,
    skip: number,
    limit: number,
  ) {
    const response: any = await performanceService.getMyPerformanceDataBySearch(
      current_employee_id,
      current_user_id,
      search,
      skip,
      limit,
    );
    if (response.status === 200) {
      dispatch(setPerformanceData(response?.data));
    } else {
      return;
    }
  }
  //GET Performance Data By Search and Filter
  async function getPerfomanceDataBySearchAndFilter(
    current_employee_id: number,
    current_user_id: number,
    status: string,
    search: string,
    skip: number,
    limit: number,
  ) {
    try {
      const response: any =
        await performanceService.getMyPerformanceDataBySearchAndFilter(
          current_employee_id,
          current_user_id,
          status,
          search,
          skip,
          limit,
        );
      if (response.status === 200) {
        dispatch(setPerformanceData(response?.data));
      }
    } catch (error: any) {
      toast.error(error.message);
    }
  }
  async function getMyTeamEmployees() {
    try {
      const response: any = await performanceService.getMyTeamEmployees(
        userId,
        employeeId,
      );
      // console.log(employeeId);
      dispatch(setMyTeamEmployees(response?.data));
    } catch (err: any) {
      console.log('{id}/teams' + err.message);
      dispatch(setMyTeamEmployees([]));
    }
  }

  return <></>;
}
export default DTOPerfomance;
